import React, { lazy, Suspense } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
import TierPromotionCard, { Props as TierPromotionCardProps } from '../TierPromotionCard';

const TierPromotionCardWithFellaTooltip = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "ms_ftue" */
        './TierPromotionCardWithFellaTooltip'
      )
  )
);

export interface Props extends TierPromotionCardProps {
  isPostsFeedCard?: boolean;
}

export const LoadableTierPromotionCardWithFellaTooltip: React.FC<Props> = ({
  isPostsFeedCard,
  ...props
}) => {
  const isMounted = useIsMounted();
  const loading = <TierPromotionCard {...props} />;

  if (!isMounted) {
    return loading;
  }

  return (
    <ErrorBoundary debugComponent="LoadableTierPromotionCardWithFellaTooltip">
      <Suspense fallback={loading}>
        <TierPromotionCardWithFellaTooltip {...props} isPostsFeedCard={isPostsFeedCard} />
      </Suspense>
    </ErrorBoundary>
  );
};
LoadableTierPromotionCardWithFellaTooltip.displayName = 'LoadableTierPromotionCardWithFellaTooltip';

export default LoadableTierPromotionCardWithFellaTooltip;
